window.addEventListener('DOMContentLoaded', () => {
    var lang='en';
    let errorMessageEn = document.querySelector(".errormessage-en");
    errorMessageEn.style.opacity = 1;
    if (navigator.languages) {
          for (let i = 0; i < navigator.languages.length; i++) {
                langTemp = navigator.languages[i].split('-')[0];
                if (langTemp == 'de'){
                      lang='de';
                      break;
                }
                if (langTemp == 'en'){
                      lang='en';
                      break;
                }
          }

          if(lang == 'de'){
                let errorMessageDe = document.querySelector(".errormessage-de");
                let errorMessageEn = document.querySelector(".errormessage-en");
                errorMessageDe.style.display = "inherit"; 
                errorMessageEn.style.display = "none"; 
          }

    }
});